import { useRef } from 'react';

export const useSaveOnMountArrayState = <T>(state: T[]) => {
  const savedStateRef = useRef([...state]);

  return savedStateRef.current;
};
